/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import withStyles from '@material-ui/core/styles/withStyles';

const style = theme => ({
  rootParent: {
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  },
  permissionRow: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 1rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '&:first-child': {
      flexBasis: '80%',
    },
  },
  switch: {
    textAlign: 'right',
  },
  header: {
    margin: '1rem 0 1rem',
  },
  gutterBottom: {
    marginBottom: '1rem',
  },
  // nested levels for ui
  // tree
  nested1: {
    paddingLeft: '1rem',
  },
  nested2: {
    paddingLeft: '2rem',
  },
  nested3: {
    paddingLeft: '3rem',
  },
  nested4: {
    paddingLeft: '4rem',
  },
});

class Permission extends Component {
  // handleChange = value => e => {
  //   const { onChange } = this.props;
  //   onChange(value, e.target.checked);
  // }

  render() {
    const {
      resource, readOnly, classes, onChange,
    } = this.props;

    return (
      <li>
        <React.Fragment>
          <div className={classes.header}>
            <Typography variant="headline">
              {resource.resource.split('_').join(' ')}
            </Typography>
            <Typography variant="subheading">{resource.description}</Typography>
            <Divider style={{ marginTop: '1rem' }} />
          </div>
          {resource.actions.map((action, idx) => {
            if (action.permission) {
              return (
                <div className={classes.nested1} key={idx}>
                  <ul className={classes.permissionRow}>
                    <li style={{ width: '100%' }}>
                      <Typography variant="body2">{action.action}</Typography>
                      <Typography variant="subheading">{action.description}</Typography>
                    </li>
                    <li className={classes.switch}>
                      <Switch
                        value="checkedA"
                        checked={action.enabled}
                        onChange={() => !readOnly && onChange(resource.resource, action.action, !action.enabled)}
                        color="primary"
                      />
                    </li>
                  </ul>
                  <Divider className={classes.gutterBottom} />
                </div>
              );
            }
          })}
        </React.Fragment>
      </li>
    );
  }
}

Permission.propTypes = {
  resource: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default withStyles(style)(Permission);
